import JSEncrypt from 'jsencrypt'

const publickey = process.env.VUE_APP_PUBLIC_KEY



export function setEncrypt(data) {
  if (!data) return ''
  let encrypt = new JSEncrypt()
  encrypt.setPublicKey(publickey)
  return encrypt.encrypt(data)
}

export function getEncrypt(data) {
  if (!data) return ''
  let decrypt = new JSEncrypt()
  decrypt.setPrivateKey(privatekey)
  return decrypt.decrypt(data)
}
